module.exports = __webpack_public_path__ + "img/full-recycle-bin.70882196.png";